import React from 'react'
import { Button, Table, Container, Input, Label, Row, Col } from 'reactstrap'
const { getAllEquips, insertEquip, updateEquip, deleteEquip } = require('../../model/request/equip')

class EquipAdminViewController extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            equips: [],
            newEquip: { name: '', quantity: 1 },
        }
    }

    componentDidMount() {
        getAllEquips().then(
            (result) => this.setState({ equips: result.data.equips }),
            (error) => this.props.showError(error),
        )
    }

    saveNew() {
        if (!this.state.newEquip.name.trim()) return
        insertEquip(this.state.newEquip).then(
            (result) => {
                this.setState((s) => ({
                    equips: [...s.equips, result.data.equip],
                    newEquip: { name: '', quantity: 1 },
                }))
            },
            (error) => this.props.showError(error),
        )
    }

    save(equip) {
        updateEquip(equip).then(
            () => {},
            (error) => this.props.showError(error),
        )
    }

    delete(id) {
        deleteEquip(id).then(
            () => this.setState((s) => ({ equips: s.equips.filter((e) => e.id !== id) })),
            (error) => this.props.showError(error),
        )
    }

    render() {
        return (
            <Container>
                <h3 style={{ marginTop: '20px', marginBottom: '20px' }}>Equipment</h3>
                <Row><Col><div style={{'overflowX': 'auto'}}><Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th style={{ width: '120px' }}>Quantity</th>
                            <th style={{ width: '80px' }}>Save</th>
                            <th style={{ width: '80px' }}>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.equips.map((equip) => (
                            <tr key={equip.id}>
                                <td>
                                    <Input
                                        value={equip.name}
                                        onChange={(e) => {
                                            const equips = this.state.equips.map((x) =>
                                                x.id === equip.id ? { ...x, name: e.target.value } : x
                                            )
                                            this.setState({ equips })
                                        }}
                                    />
                                </td>
                                <td>
                                    <Input
                                        type="number"
                                        min="0"
                                        value={equip.quantity}
                                        onChange={(e) => {
                                            const equips = this.state.equips.map((x) =>
                                                x.id === equip.id ? { ...x, quantity: parseInt(e.target.value) || 0 } : x
                                            )
                                            this.setState({ equips })
                                        }}
                                    />
                                </td>
                                <td>
                                    <Button color="primary" onClick={() => this.save(equip)}>Save</Button>
                                </td>
                                <td>
                                    <Button color="danger" onClick={() => this.delete(equip.id)}>Delete</Button>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <td>
                                <Input
                                    placeholder="New equipment name…"
                                    value={this.state.newEquip.name}
                                    onChange={(e) => this.setState({ newEquip: { ...this.state.newEquip, name: e.target.value } })}
                                />
                            </td>
                            <td>
                                <Input
                                    type="number"
                                    min="0"
                                    value={this.state.newEquip.quantity}
                                    onChange={(e) => this.setState({ newEquip: { ...this.state.newEquip, quantity: parseInt(e.target.value) || 0 } })}
                                />
                            </td>
                            <td>
                                <Button color="success" onClick={() => this.saveNew()}>Add</Button>
                            </td>
                            <td></td>
                        </tr>
                    </tbody>
                </Table></div></Col></Row>
            </Container>
        )
    }
}

export default EquipAdminViewController
